import axiosInstance from '../utils/axiosConfig';

export const exchangeCodeForToken = async (code: string) => {
  const response = await axiosInstance.post('/api/auth/yandex', { code });
  return response.data;
}; 